import React from 'react'

import ModalV5 from "../../../app/ui/modal/v5/v5"
import EntitySelector from "../../gd-components/entity-selector/selector"
import {EntitySelectorEntityType, EntitySelectorMode} from "../../gd-components/entity-selector/@const"
import {MentionOption} from "../../gd-components/editor/plugins/mentions/option"
import closeModal from "../../gd/utils/close-modal"

type Props = {
    onSelected          : {(entity: MentionOption): void}

    // The tab to open on -- what the caller's add menu picked. TASK when the
    // caller has no opinion.
    initialEntityType?  : EntitySelectorEntityType

    // The owner's own project, if any -- expands it (and its parents) in the
    // Task/Project tabs so the picker opens already scoped to it.
    projectId?          : ID
}

// Picks the entity to link as a related item. Opened by `add-relation-modal.tsx`.
//
// The User tab is hidden: a related user IS a task-user, and the relations
// collection drops user links anyway (`RelationsCollection.canShow`).
export default function ModalAddRelation(props: Props) {

    const onEntitySelected = (entity: MentionOption) => {
        closeModal()
        props.onSelected(entity)
    }

    // The modal has no header of its own: the selector's own sidebar heading IS
    // the modal title, and its content column carries the close control. Both
    // come with MODAL mode, along with filling the box rather than sizing itself.
    return (
        <ModalV5 className="w-880 h-85p flex-column">
            <div className="flex-column-top-stretch flex-1 min-h-0">
                <EntitySelector
                    mode                = {EntitySelectorMode.MODAL}
                    title               = "Add related item"
                    projectId           = {props.projectId}
                    initialEntityType   = {props.initialEntityType || EntitySelectorEntityType.TASK}
                    excludedEntityTypes = {[EntitySelectorEntityType.USER]}
                    onEntitySelected    = {onEntitySelected}
                    onClose             = {closeModal}
                />
            </div>
        </ModalV5>
    )
}
